import moment from 'moment-timezone';

/**
 * Parse a calendar focus date for FullCalendar's `gotoDate` / `initialDate`.
 *
 * A date-only `YYYY-MM-DD` string must be read in the calendar's `timezone`,
 * NOT as UTC midnight. `new Date('2026-07-12')` is UTC midnight, and the
 * calendar is mounted with `timeZone={timezone}` + `firstDay={0}` (Sun–Sat), so
 * that instant re-projects a day earlier at any negative UTC offset (US zones) —
 * landing the view on the previous week. This surfaced as the "Next week" /
 * "Next 2 weeks" find-time presets (which always anchor on a Sunday) opening the
 * wrong week for US accounts while the slots were applied correctly.
 *
 * A `Date` (or a full ISO timestamp string carrying a zone/offset) is already an
 * unambiguous instant, so it's returned/parsed without a UTC-midnight guess.
 */
export const parseFocusDate = (date: string | Date, timezone: string): Date =>
  typeof date === 'string' ? moment.tz(date, timezone).toDate() : date;
